import { defineTokens } from "@chakra-ui/react/styled-system";
import { themeTokens } from "@commercetools/nimbus-tokens";

export const fonts = defineTokens.fonts(themeTokens.fontFamily);
